import React from 'react';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAuth } from '@strongio/pretrained-dashboard/auth';
import loadMessages from '@strongio/pretrained-dashboard/messages';
import CompactLayout from '@strongio/pretrained-dashboard/layouts/CompactLayout';
import LoginForm from '@strongio/pretrained-dashboard/views/logistration/login/LoginForm';
import SocialLogin from '@strongio/pretrained-dashboard/views/logistration/login/SocialLogin';
import LoginSubtitle from '@strongio/pretrained-dashboard/views/logistration/login/Subtitle';

export default function LoginView() {
  const router = useRouter();
  const { setToken } = useAuth();
  const t = useTranslations('login');

  const authComplete = (accessToken) => {
    setToken(accessToken);
    const next = router.query.next || '/';

    if (accessToken.requireMfa) {
      window.location.href = `/login/mfa?next=${encodeURIComponent(next)}`;
    } else {
      const url = new URL(next, window.location.href);
      router.push(url);
    }
  };

  return /*#__PURE__*/(
    React.createElement(CompactLayout, {
      title: t('sign-in-to-your-account'),
      subtitle: /*#__PURE__*/React.createElement(LoginSubtitle, null) }, /*#__PURE__*/

    React.createElement(LoginForm, { authComplete: authComplete }), /*#__PURE__*/
    React.createElement(SocialLogin, { authComplete: authComplete })));


}

LoginView.getInitialProps = async ({ locale }) => {
  const messages = await loadMessages('login', locale);

  return {
    messages,
    title: messages.login.title,
    noAuth: true };

};